export default __webpack_public_path__ + "static/medtner-op-39-tragica-8bb3d41969c5f6f326b2846de72286fe.mp3";